import { useQuery } from 'react-query'
import { removeEmptyFieldObject, useLocale } from '@plandi/common'

import { projectKeys } from '../projects.constants'
import { projectsApi } from '../projects.api'
import { QueryParamsProjects } from '../projects.types'

export const useQueryProjects = (params?: QueryParamsProjects) => {
  const paramsOptions = removeEmptyFieldObject(params ?? {})
  const locale = useLocale()

  return useQuery(projectKeys.list(paramsOptions), () =>
    projectsApi.getProjects(locale, paramsOptions)
  )
}
